import { Link } from 'react-router-dom';
import * as $ from 'jquery';
import { formatPhoneNumber, getCustomLabel, getShortName } from '../../../../itrust_common/components/HelperFunctions';
import DateFormatView from '../../../../itrust_common/components/others/DateFormatView';
import { connect, useDispatch } from 'react-redux';
import { quickActionsReset } from '../../../../redux/actions/dashboard/quickActionActions';

function ExamPatientInfo(props) {
  const { patient, visionInsuranceTemplate, medicalInsuranceTemplate } = props
  const dispatch = useDispatch()

  const handlePatientRedirect = () => {
    $('#editExamForm-modal').modal('hide');
    $('#prescription-modal').modal('hide');
    dispatch(quickActionsReset())
  }

  return (
    <>
      <div className="border-right border-light text-center p-5 d-flex flex-column align-items-center justify-content-center">
        {getShortName(patient, 'mr-5 width-6 height-6', 'mr-5 width-6 height-6 font-size-40')}
        <h5 className="mt-2 text-nowrap">
          <Link to={`/patients/${patient.id}/overview`} className="btn-link" onClick={handlePatientRedirect}>{patient.name}</Link>
        </h5>
          {patient?.nickname && (
            <h6 className='py-2'>"{patient?.nickname}"</h6>
          )}   
      </div>
      <div className="p-6">
        <div>
          <span className="text-nowrap">DOB & Age:</span>
          <span className="text-muted pl-2 text-nowrap">
            <DateFormatView date={patient.date_of_birth} /> | {patient.age}
          </span>
        </div>
        <div>
          <span>Phone:</span>
          <span className="text-muted text-muted pl-2 text-nowrap">{formatPhoneNumber(patient.cell_phone)}</span>
        </div>
        <div>
          <span>Email:</span>
          <span className="text-muted text-muted pl-2 text-nowrap">{patient.email}</span>
        </div>
        <div>
          <span className="text-nowrap">{visionInsuranceTemplate && getCustomLabel(visionInsuranceTemplate, 'insurance')}:</span>
          <span className="text-muted text-muted pl-2">
            {patient.patient_vision_insurance && patient.patient_vision_insurance.insurance_name}
            {patient.vision_insurance_plan_name && ` | ${patient.vision_insurance_plan_name}`}
          </span>
        </div>
        <div>
          <span className="text-nowrap">{medicalInsuranceTemplate && getCustomLabel(medicalInsuranceTemplate, 'insurance')}:</span>
          <span className="text-muted text-muted pl-2">
            {patient.patient_medical_insurance && patient.patient_medical_insurance.insurance_name}
            {patient.medical_insurance_plan_name && ` | ${patient.medical_insurance_plan_name}`}
          </span>
        </div>
      </div>
    </>
  )
}

const mapStateToProps = (state) => {
  const { setting: { patientTemplate: { patient_template } } } = state
  const patientInsuranceData = patient_template.personal_information?.insurance_detail?.fields
  return {
    visionInsuranceTemplate: patientInsuranceData?.vision_insurance?.fields,
    medicalInsuranceTemplate: patientInsuranceData?.medical_insurance?.fields,
  }
}

export default connect(mapStateToProps)(ExamPatientInfo)